import queryKeys from '@/constants/queryKeys';
import { screenerResultsByTokenGet } from '@/services/api/requests/public-screener';
import { useQuery } from '@tanstack/react-query';

const useScreenerResultsByToken = ( token?: string ) => {
  const { isLoading, data, isError, error, isSuccess } = useQuery({
    queryKey: [queryKeys.publicScreener.getResults, token],
    enabled: !!token,
    queryFn: async () => {
      if (token) {
        const response = await screenerResultsByTokenGet({token});

        return response;
      }
    },
  });

  return { isLoading, data, isError, error, isSuccess };
};

export default useScreenerResultsByToken;
